import BreathingRateModal from "./index";

export default function BreathingRateModalExamples() {
  return <BreathingRateModal />;
}
